<template>
    <div class="card card-small" v-if="fetched">
        <div class="card-body p-0 pb-3 text-center">
            <table class="table mb-0 responsive-table">
                <thead class="bg-light">
                    <tr>
                        <th scope="col" class="border-0 id-cell">ID</th>
                        <th scope="col" class="border-0">Typ dokumentu</th>
                        <th scope="col" class="border-0">Nazwa</th>
                        <th scope="col" class="border-0">Plik</th>
                        <th scope="col" class="border-0 action-cell">Akcja</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(document, index) in documents" :key="document.id">
                        <td>
                            <dt>ID</dt>
                            <dd>{{ document.id }}</dd>
                        </td>
                        <td>
                            <dt>Rodzaj</dt>
                            <dd>
                                {{ document.type}}
                            </dd>
                        </td>
                        <td>
                            <dt>Nazwa</dt>
                            <dd>
                                {{ document.name}}
                            </dd>
                        </td>
                        <td>
                            <dt>Plik</dt>
                            <dd>
                                <a href="#" @click.prevent="downloadFile(document)">{{ document.filename}}</a>
                            </dd>
                        </td>
                        <td>
                            <dt>Akcja</dt>
                            <dd>
                                <d-button theme="danger"  class="mr-1 mr-3" @click.prevent="removeDocument(document)"><i class="material-icons">delete</i> Usuń</d-button>
                            </dd>
                        </td>
                    </tr>
                </tbody>
            </table>
            <p v-if="documents.length < 1" class="text-info">Brak dokumentów do wyświetlenia.</p>
        </div>
    </div>
</template>

<script>
    import FileSaver from 'file-saver'

    export default {
        name: "DocumentsList",
        props: {
            props: {
                type: Array,
                default: ()=>[]
            }
        },
        data(){
            return{
                documents: [],
                fetched: true
            }
        },
        methods: {
            downloadFile(doc){
                axios.post('api/clients/download-document',
                    {id: doc.id,},
                    {responseType: 'blob'}
                ).then(response => {
                    let blob = new File([response.data], doc.filename );
                    FileSaver.saveAs(blob);
                }).catch((error)=>{
                    Vue.swal({
                        title: 'Nie udało się pobrać pliku',
                        text: 'Wystąpił błąd podczas pobierania. Spróbuj ponownie za jakiś czas.',
                        type: 'error',
                    });
                });
            },
            removeDocument(document){
                Vue.swal({
                    title: 'Uwaga',
                    html: 'Czy potwierdzasz usunięcie<br /><strong>' + document.type + '</strong><br />z listy dokumentów?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Tak',
                    cancelButtonText: 'Nie',
                    buttonsStyling: true
                }).then((logout) => {
                    if(logout.value){
                        axios.post('api/clients/remove-document', {
                            id: document.id
                        }).then(response => {
                          if (response.data.cannot_delete && response.data.cannot_delete === 1) {
                            Vue.swal({
                              type: 'info',
                              html: 'By usunąć dokument <strong>' + document.type + '</strong>,<br /> odepnij go najpierw z&nbsp;umów w&nbsp;których uczestniczy',
                              showConfirmButton: true,
                            })
                          } else {
                            this.$emit('removeDocument', document.id);
                            Vue.swal({
                              type: 'success',
                              title: 'Dokument został usunięty.',
                              showConfirmButton: true,
                            });
                          }
                        }).catch((errors) =>{
                            console.log(errors);
                        })
                    }
                }).catch((errors) =>{
                    console.log(errors);
                })
            }
        },
        mounted(){
            this.documents = this.props ? this.props : this.documents;
            this.fetched = true;
        },
        watch: {
            props: {
                handler: function(to) {
                    this.documents = to;
                },
                deep: true
            }
        }
    }
</script>

<style>
    .action-cell, .id-cell{
        width: 200px;
    }
</style>
